"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastCard = exports.Container = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var polished_1 = require("polished");
exports.Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 999;\n  bottom: ", ";\n  right: ", ";\n\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  max-width: ", ";\n\n  @media (max-width: 650px) {\n    left: ", ";\n    right: ", ";\n    bottom: ", ";\n    max-width: none;\n  }\n"], ["\n  position: fixed;\n  z-index: 999;\n  bottom: ", ";\n  right: ", ";\n\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  max-width: ", ";\n\n  @media (max-width: 650px) {\n    left: ", ";\n    right: ", ";\n    bottom: ", ";\n    max-width: none;\n  }\n"])), (0, polished_1.rem)(24), (0, polished_1.rem)(24), (0, polished_1.rem)(12), (0, polished_1.rem)(360), (0, polished_1.rem)(16), (0, polished_1.rem)(16), (0, polished_1.rem)(16));
exports.ToastCard = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n\n  padding: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  box-shadow: 0 ", " ", " rgba(0, 0, 0, 0.35);\n\n  border-left: 3px solid\n    ", ";\n\n  svg {\n    flex-shrink: 0;\n    margin-top: ", ";\n    color: ", ";\n  }\n\n  span {\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n\n  padding: ", ";\n  border-radius: ", ";\n  border: 1px solid ", ";\n  background: ", ";\n  box-shadow: 0 ", " ", " rgba(0, 0, 0, 0.35);\n\n  border-left: 3px solid\n    ", ";\n\n  svg {\n    flex-shrink: 0;\n    margin-top: ", ";\n    color: ", ";\n  }\n\n  span {\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n  }\n\n  ", "\n"])), (0, polished_1.rem)(12), (0, polished_1.rem)(16), (0, polished_1.rem)(14), function (_a) {
    var theme = _a.theme;
    return theme.colors.border;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, (0, polished_1.rem)(10), (0, polished_1.rem)(30), function (_a) {
    var type = _a.type;
    return (type === 'success' ? '#22c55e' : '#ef4444');
}, (0, polished_1.rem)(2), function (_a) {
    var type = _a.type;
    return (type === 'success' ? '#22c55e' : '#ef4444');
}, (0, polished_1.rem)(15), (0, polished_1.rem)(22), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue[900];
}, function (_a) {
    var type = _a.type;
    return type === 'error' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      span {\n        opacity: 0.9;\n      }\n    "], ["\n      span {\n        opacity: 0.9;\n      }\n    "])));
});
var templateObject_1, templateObject_2, templateObject_3;
